import React, { useState, useEffect } from "react";
import $ from "jquery";
import Cart from '../commerce/Cart'
import slugify from '../utils/slugify'


const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);              // mobile menu open
  const [openMenu, setOpenMenu] = useState(null);           // desktop dropdown key | null (hover-driven)
  const [openMobileSub, setOpenMobileSub] = useState(null); // mobile dropdown key | null
  const [brands, setBrands] = useState([]);
  const [exhibitions, setExhibitions] = useState([]);
  const [overviewTitles, setOverviewTitles] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [formData, setFormData] = useState({ name: '', email: '' });

  const handleTogglePopup = () => setIsPopupOpen((p) => !p);

  // Mobile dropdowns are tap-based (hover is unavailable on touch); desktop uses hover.
  const toggleMobileSub = (key) => setOpenMobileSub((p) => (p === key ? null : key));
  const closeMobile = () => {
    setIsOpen(false);
    setOpenMobileSub(null);
  };

  // Close the mobile menu (and the subscribe modal) on Escape
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') {
        setIsOpen(false);
        setOpenMobileSub(null);
        setIsPopupOpen(false);
      }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/brands`);
        const data = await response.json();

        if (data.length > 1) {
          const temp = data[0];
          data[0] = data[1];
          data[1] = temp;
        }

        // Use the slug stored on each record. Don't rebuild it here — the
        // backend's slugify strips accents/punctuation, so re-deriving it
        // client-side produced links the API couldn't match.
        setBrands(data);
      } catch (error) {
        console.error('Error fetching portfolio titles:', error);
      }
    };
    fetchBrands();
  }, []);

  // FETCH OVERVIEW TITLES — drives the "overview" dropdown
  useEffect(() => {
    const fetchOverviewTitles = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/overview-titles`);
        if (!response.ok) return;
        setOverviewTitles(await response.json());
      } catch (error) {
        console.error('Error fetching overview titles:', error);
      }
    };
    fetchOverviewTitles();
  }, []);

  // FETCH EXHIBITION
  useEffect(() => {
    const fetchExhibitions = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/exhibitions`);
        const data = await response.json();

        if (data.length > 1) {
          const temp = data[0];
          data[0] = data[1];
          data[1] = temp;
        }

        // Same here: keep the stored slug rather than re-deriving it.
        setExhibitions(data);
      } catch (error) {
        console.error('Error fetching exhibition titles:', error);
      }
    };
    fetchExhibitions();
  }, []);

  const subscribeForm = async (e) => {
    e.preventDefault()
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        alert('Form submitted successfully')
        setFormData({ name: '', email: '' });
        setIsPopupOpen(false);
      } else {
        console.error('Form submission failed');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  // Custom easing function: easeInOutExpo
  function easeInOutExpo(t, b, c, d) {
    if ((t /= d / 2) < 1) return (c / 2) * Math.pow(2, 10 * (t - 1)) + b;
    return (c / 2) * (-Math.pow(2, -10 * --t) + 2) + b;
  }

  // Smooth scroll with custom easing
  useEffect(() => {
    $(function () {
      $("a.page-scroll").bind("click", function (event) {
        const $anchor = $(this);
        const target = $($anchor.attr("href")).offset().top;
        const duration = 1500;
        const start = $(window).scrollTop();
        const change = target - start;
        const increment = 20;
        let currentTime = 0;

        function animateScroll() {
          currentTime += increment;
          const val = easeInOutExpo(currentTime, start, change, duration);
          $(window).scrollTop(val);
          if (currentTime < duration) {
            setTimeout(animateScroll, increment);
          }
        }
        animateScroll();
        event.preventDefault();
      });
    });
  }, []);

  // Shared class strings
  const desktopLink =
    "text-[11px] xl:text-[12px] text-[#e4e4e3] hover:text-[#b7a78b] uppercase tracking-[0.18em] whitespace-nowrap transition-colors duration-200";
  // Outlined button — sits better against the dark bar than a solid tan block
  const subscribeBtn =
    "border border-[#b7a78b] text-[#b7a78b] hover:bg-[#b7a78b] hover:text-[#252525] px-5 py-2.5 text-[10px] xl:text-[11px] uppercase tracking-[0.2em] whitespace-nowrap transition-colors duration-300";
  const desktopDropdownItem =
    "font-dropdown capitalize block py-2 text-[15px] text-[#cfcfca] hover:text-[#b7a78b] whitespace-nowrap transition-colors duration-150";
  const mobileTopItem =
    "flex w-full items-center justify-center gap-1 px-4 py-3 text-[13px] text-[#e4e4e3] uppercase tracking-[0.2em] hover:bg-gray-800";
  const mobileSubItem =
    "font-dropdown block px-4 py-2 text-[15px] text-[#e4e4e3] hover:text-[#b7a78b] capitalize transition-colors duration-150";

  // Slide-down dropdown panel (sits above the full-page overlay)
  const panelBase =
    "absolute left-0 top-full w-[280px] px-1 z-50 origin-top transition-all duration-300 ease-out";
  const panelState = (open) =>
    open ? "opacity-100 translate-y-0 visible" : "opacity-0 -translate-y-3 invisible pointer-events-none";

  return (
    <>
      <Cart />
      <nav className="relative shadow-lg bg-[#252525] z-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex justify-between items-center gap-6 h-[70px] xl:h-[100px] lg:h-[90px]">
            {/* Logo */}
            <div className="font-navbar text-2xl xl:text-3xl uppercase text-[#e4e4e3] font-semibold tracking-[0.1em] shrink-0">
              <a href="/">Sope A.</a>
            </div>

            {/* ─── Desktop menu (lg and up) — centered between the logo and Subscribe ─── */}
            <nav className="font-navbar hidden lg:flex flex-1 items-center justify-center lg:space-x-6 xl:space-x-10">
              {/* Overview */}
              <div
                className="relative"
                onMouseEnter={() => setOpenMenu('overview')}
                onMouseLeave={() => setOpenMenu(null)}
              >
                <button type="button" className={desktopLink}>
                  overview
                </button>
                <div className={`${panelBase} ${panelState(openMenu === 'overview')}`}>
                  {overviewTitles.map((t) => (
                    <a
                      key={t._id}
                      href={`/overview/${t.slug || slugify(t.name)}`}
                      className={desktopDropdownItem}
                    >
                      {t.name}
                    </a>
                  ))}
                </div>
              </div>

              {/* Select Projects */}
              <div
                className="relative"
                onMouseEnter={() => setOpenMenu('projects')}
                onMouseLeave={() => setOpenMenu(null)}
              >
                <button type="button" className={desktopLink}>
                  select projects
                </button>
                <div className={`${panelBase} ${panelState(openMenu === 'projects')}`}>
                  {brands.map((brand) => (
                    <a key={brand._id} href={`/portfolios/${brand.slug || slugify(brand.name)}`} className={desktopDropdownItem}>
                      {brand.name}
                    </a>
                  ))}
                </div>
              </div>

              {/* Exhibitions */}
              <div
                className="relative"
                onMouseEnter={() => setOpenMenu('exhibitions')}
                onMouseLeave={() => setOpenMenu(null)}
              >
                <button type="button" className={desktopLink}>
                  exhibitions
                </button>
                <div className={`${panelBase} ${panelState(openMenu === 'exhibitions')}`}>
                  {exhibitions.map((exhibition) => (
                    <a key={exhibition._id} href={`/exhibitions/${exhibition.slug || slugify(exhibition.name)}`} className={desktopDropdownItem}>
                      {exhibition.name}
                    </a>
                  ))}
                </div>
              </div>

              <a href="/motions" className={`${desktopLink} page-scroll`}>motion</a>
              <a href="/on-set" className={`${desktopLink} page-scroll`}>on set</a>
              <a href="/learn-more" className={`${desktopLink} page-scroll`}>about</a>
              {/* <a href="/contact" className={`${desktopLink} page-scroll`}>contact</a> */}
            </nav>

            {/* ─── Subscribe (desktop) — kept out of the nav so the links stay centered ─── */}
            <div className="hidden lg:flex shrink-0">
              <button type="button" onClick={handleTogglePopup} className={subscribeBtn}>
                Subscribe
              </button>
            </div>

            {/* ─── Hamburger button (below lg) ─── */}
            <div className="lg:hidden flex items-center">
              <button
                onClick={() => setIsOpen((o) => !o)}
                type="button"
                aria-label="Toggle menu"
                aria-expanded={isOpen}
                className="text-[#e4e4e3] hover:text-white focus:outline-none"
              >
                <svg className="h-7 w-7" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  {isOpen ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  ) : (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
                  )}
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* ─── Mobile / tablet menu (below lg) ─── */}
        <div className={`lg:hidden overflow-hidden transition-all duration-500 ease-in-out bg-[#252525] ${isOpen ? "max-h-[85vh] overflow-y-auto opacity-100" : "max-h-0 opacity-0"}`}>
          <div className="font-navbar flex flex-col py-2 shadow-sm">
            {/* Overview */}
            <button className={mobileTopItem} onClick={() => toggleMobileSub('overview')} aria-expanded={openMobileSub === 'overview'}>
              overview
            </button>
            {openMobileSub === 'overview' && (
              <div className="bg-[#1d1d1d] py-1 text-center">
                {overviewTitles.map((t) => (
                  <a
                    key={t._id}
                    href={`/overview/${t.slug || slugify(t.name)}`}
                    onClick={closeMobile}
                    className={mobileSubItem}
                  >
                    {t.name}
                  </a>
                ))}
              </div>
            )}

            {/* Select Projects */}
            <button className={mobileTopItem} onClick={() => toggleMobileSub('projects')} aria-expanded={openMobileSub === 'projects'}>
              select projects
            </button>
            {openMobileSub === 'projects' && (
              <div className="bg-[#1d1d1d] py-1 text-center">
                {brands.map((brand) => (
                  <a key={brand._id} href={`/portfolios/${brand.slug || slugify(brand.name)}`} onClick={closeMobile} className={mobileSubItem}>
                    {brand.name}
                  </a>
                ))}
              </div>
            )}

            {/* Exhibitions */}
            <button className={mobileTopItem} onClick={() => toggleMobileSub('exhibitions')} aria-expanded={openMobileSub === 'exhibitions'}>
              exhibitions
            </button>
            {openMobileSub === 'exhibitions' && (
              <div className="bg-[#1d1d1d] py-1 text-center">
                {exhibitions.map((exhibition) => (
                  <a key={exhibition._id} href={`/exhibitions/${exhibition.slug || slugify(exhibition.name)}`} onClick={closeMobile} className={mobileSubItem}>
                    {exhibition.name}
                  </a>
                ))}
              </div>
            )}

            <a href="/motions" className={mobileTopItem} onClick={closeMobile}>motion</a>
            <a href="/on-set" className={mobileTopItem} onClick={closeMobile}>on set</a>
            <a href="/learn-more" className={mobileTopItem} onClick={closeMobile}>about</a>
            {/* <a href="/contact" className={mobileTopItem} onClick={closeMobile}>contact</a> */}

            <div className="flex justify-center py-4">
              <button
                type="button"
                onClick={() => { setIsOpen(false); handleTogglePopup(); }}
                className={subscribeBtn}
              >
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* ─── Full-page dim overlay shown while a desktop dropdown is open ─── */}
      <div
        aria-hidden="true"
        onMouseEnter={() => setOpenMenu(null)}
        className={`hidden lg:block fixed inset-x-0 bottom-0 top-[90px] xl:top-[100px] bg-[#252525]/90 z-40 transition-opacity duration-300 ${openMenu ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
      />

      {/* ─── Subscribe modal — small centered box (shared by both menus) ─── */}
      {isPopupOpen && (
        <div
          className="fixed inset-0 z-[60] flex items-center justify-center px-4"
          role="dialog"
          aria-modal="true"
          aria-labelledby="subscribe-title"
        >
          {/* Backdrop — click anywhere outside the box to close */}
          <div
            className="absolute inset-0 bg-black/80 backdrop-blur-sm"
            onClick={() => setIsPopupOpen(false)}
          />

          {/* Box */}
          <div className="relative w-full max-w-md bg-[#252525] border border-[#484540] shadow-2xl px-8 py-9">
            {/* Close */}
            <button
              type="button"
              onClick={() => setIsPopupOpen(false)}
              aria-label="Close"
              className="absolute top-4 right-4 text-[#8a8175] hover:text-[#e4e4e3] transition-colors"
            >
              <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <h2
              id="subscribe-title"
              className="font-navbar text-[#e7ddd3] text-xl uppercase tracking-[0.18em] mb-2"
            >
              Subscribe
            </h2>
            <p className="font-dropdown text-[#b7a78b] text-[13px] leading-relaxed mb-7">
              New work, exhibitions and stories — straight to your inbox.
            </p>

            <form onSubmit={subscribeForm} className="space-y-4">
              <input
                type="text"
                id="name"
                name="name"
                placeholder="NAME"
                value={formData.name}
                onChange={handleInputChange}
                required
                className="w-full bg-transparent border border-[#484540] px-4 py-3 text-[12px] tracking-[0.1em] text-[#e4e4e3] placeholder:text-[#6f675c] focus:outline-none focus:border-[#b7a78b] transition-colors duration-200"
              />
              <input
                type="email"
                id="email"
                name="email"
                placeholder="EMAIL"
                value={formData.email}
                onChange={handleInputChange}
                pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}"
                required
                className="w-full bg-transparent border border-[#484540] px-4 py-3 text-[12px] tracking-[0.1em] text-[#e4e4e3] placeholder:text-[#6f675c] focus:outline-none focus:border-[#b7a78b] transition-colors duration-200"
              />

              <button
                type="submit"
                className="w-full bg-[#b7a78b] hover:bg-[#d0c3a6] text-[#252525] py-3.5 text-[11px] font-semibold uppercase tracking-[0.2em] transition-colors duration-300"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
